import { BaseBehavior, NodeEvent } from '@antv/g6'

const TreeEvent = {
  COLLAPSE_EXPAND: 'collapse-expand',
  ADD_CHILD: 'add-child',
}

export class CollapseExpandTree extends BaseBehavior {
  constructor(context, options) {
    super(context, options)
    this.bindEvents()
  }

  update(options) {
    this.unbindEvents()
    super.update(options)
    this.bindEvents()
  }

  bindEvents() {
    const { graph } = this.context

    graph.on(NodeEvent.POINTER_ENTER, this.showIcon)
    graph.on(NodeEvent.POINTER_LEAVE, this.hideIcon)
    graph.on(TreeEvent.COLLAPSE_EXPAND, this.onCollapseExpand)
    graph.on(TreeEvent.ADD_CHILD, this.addChild)
  }

  unbindEvents() {
    const { graph } = this.context

    graph.off(NodeEvent.POINTER_ENTER, this.showIcon)
    graph.off(NodeEvent.POINTER_LEAVE, this.hideIcon)
    graph.off(TreeEvent.COLLAPSE_EXPAND, this.onCollapseExpand)
    graph.off(TreeEvent.ADD_CHILD, this.addChild)
  }

  status = 'idle'

  showIcon = event => {
    this.setIcon(event, true)
  }

  hideIcon = event => {
    this.setIcon(event, false)
  }

  setIcon = (event, show) => {
    if (this.status !== 'idle') return
    const { target } = event
    const id = target.id
    const { graph, element } = this.context
    graph.updateNodeData([{ id, style: { showIcon: show } }])
    element.draw({ animation: false, silence: true })
  }

  onCollapseExpand = async event => {
    this.status = 'busy'
    const { id, collapsed } = event
    const { graph } = this.context
    if (collapsed) await graph.collapseElement(id)
    else await graph.expandElement(id)
    this.status = 'idle'
  }

  addChild(event) {
    const { onCreateChild = () => ({ id: `${Date.now()}`, style: { labelText: 'new node' } }) } = this.options
    const { graph } = this.context
    const datum = onCreateChild(event.id)
    graph.addNodeData([datum])
    graph.addEdgeData([{ source: event.id, target: datum.id }])
    const parent = graph.getNodeData(event.id)
    graph.updateNodeData([{ id: event.id, children: [...(parent.children || []), datum.id], style: { collapsed: false } }])
    graph.render()
  }
}
